import { render, staticRenderFns } from "./list-inspections.vue?vue&type=template&id=2844bcd8"
import script from "./list-inspections.vue?vue&type=script&lang=js"
export * from "./list-inspections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports